import {Injectable} from "@angular/core";
import {CoreApiService} from "../../../core/service/core-api.service";
import {Observable} from "rxjs";

import {
  TicketCommentDto,
  TicketDocumentDto,
  TicketDocumentListEntryDto,
  TicketDto,
  TicketPostComment
} from "../types/tickets.types";
import {HttpEvent} from "@angular/common/http";
import {BinaryDocumentServiceInterface} from "../../../core/service/binary-document-service.interface";

@Injectable({ providedIn: 'root' })
export abstract class TicketsApiService implements BinaryDocumentServiceInterface{

  endPoint: string = "mvseu/eu/tickets"

  constructor(
    protected coreApiService: CoreApiService) {
  }

  public list() : Observable<TicketDto[]> {
    return this.coreApiService.get(`${this.endPoint}/list`);
  }

  public get(id: number): Observable<TicketDto> {
    return this.coreApiService.get(`${this.endPoint}/${id}`);
  }

  public postComment(id: number, dto: TicketPostComment): Observable<TicketCommentDto> {
    return this.coreApiService.post(dto, `${this.endPoint}/${id}/postComment`);
  }

  public updateComment(ticketId: number, commentId: number, dto: TicketPostComment): Observable<TicketCommentDto> {
    return this.coreApiService.update(dto, `${this.endPoint}/${ticketId}/posts/${commentId}`);
  }

  public deleteComment(ticketId: number, commentId: number): Observable<any> {
    return this.coreApiService.delete(`${this.endPoint}/${ticketId}/comments/${commentId}`);
  }


  public deleteDocument(ticketId: number, documentId: number): Observable<any> {
    return this.coreApiService.delete(`${this.endPoint}/${ticketId}/documents/${documentId}`);
  }

  public getDocumentBinary(ticketId: number, documentId: number): Observable<any> {
    return this.coreApiService.getDocumentBinary(`${this.endPoint}/${ticketId}/documents/${documentId}/$`);
  }

  public getDocumentBase64(ticketId: number, documentId: number): Observable<TicketDocumentDto> {
    return this.coreApiService.get(`${this.endPoint}/${ticketId}/documents/${documentId}/base64`);
  }

  public getAgentDocumentDataBase64(ticketId: number, documentId: number): Observable<TicketDocumentDto> {
    return this.coreApiService.get(`${this.endPoint}/${ticketId}/agentDocuments/${documentId}/base64`);
  }

  public createDocument(ticketId: number, file: File, dto: TicketDocumentDto): Observable<HttpEvent<TicketDocumentListEntryDto>> {
    return this.coreApiService.upload(file, `${this.endPoint}/${ticketId}/document`, dto);
  }

  public createDocumentBase64(ticketId: number, dto: TicketDocumentDto): Observable<TicketDocumentListEntryDto> {
    return this.coreApiService.post(dto, `${this.endPoint}/${ticketId}/documentBase64`);
  }


}
